import { classNames } from 'primereact/utils'

const inputMask = {
    root: ({ props, context }: { props: any; context: any }) => {
        return {
            className: classNames(
                // Font
                'leading-[normal]',
                // Spacing
                'm-0 p-3',
                // Colors
                'text-allstate-navy',
                'placeholder:text-grey-8',
                'bg-white',
                'border border-solid',
                { 'border-grey-6': !props.invalid },
                // Invalid State
                'invalid:focus:ring-warning-red',
                'invalid:hover:border-warning-red',
                { 'border-warning-red': props.invalid },
                // States
                {
                    'opacity-60 select-none pointer-events-none cursor-default':
                        context.disabled,
                },

                // Misc
                'rounded-md',
                'appearance-none',
                'transition-colors duration-200'
            ),
        }
    },
}

export default inputMask
